import { scopes as scopesConfig } from "data/authData";

const RESERVED_ROLE_KEYS = ["__scopes", "scopes"];

const normalizeScopeValues = (values) => {
	if (!Array.isArray(values)) return [];

	return [...new Set(values.filter((value) => typeof value === "string" && value))];
};

export const getFlatRoles = (role = {}) => {
	if (!role || typeof role !== "object" || Array.isArray(role)) return {};

	return Object.entries(role).reduce((acc, [key, value]) => {
		if (!RESERVED_ROLE_KEYS.includes(key) && value === true) acc[key] = true;
		return acc;
	}, {});
};

export const getFlatRoleKeys = (role = {}) => Object.keys(getFlatRoles(role));

export const getRoleScopes = (role = {}) => {
	const rawScopes = role?.__scopes || role?.scopes;

	if (!rawScopes || typeof rawScopes !== "object" || Array.isArray(rawScopes)) return {};

	return Object.entries(rawScopes).reduce((acc, [scopeKey, actionMap]) => {
		if (!actionMap || typeof actionMap !== "object" || Array.isArray(actionMap)) return acc;

		const normalizedActionMap = Object.entries(actionMap).reduce((actionAcc, [actionKey, values]) => {
			const normalizedValues = normalizeScopeValues(values);
			if (normalizedValues.length) actionAcc[actionKey] = normalizedValues;
			return actionAcc;
		}, {});

		if (Object.keys(normalizedActionMap).length) acc[scopeKey] = normalizedActionMap;

		return acc;
	}, {});
};

export const filterScopesByEnabledServices = (roleScopes = {}, flatRoles = {}) => {
	if (!roleScopes || typeof roleScopes !== "object" || Array.isArray(roleScopes)) return {};

	const knownScopesByKey = Object.values(scopesConfig).reduce((acc, scope) => {
		acc[scope.key] = scope;
		return acc;
	}, {});

	return Object.entries(roleScopes).reduce((acc, [scopeKey, actionMap]) => {
		const knownScope = knownScopesByKey[scopeKey];

		if (knownScope && flatRoles?.[knownScope.resource] !== true) return acc;
		if (!actionMap || typeof actionMap !== "object" || Array.isArray(actionMap)) return acc;

		const normalizedActionMap = Object.entries(actionMap).reduce((actionAcc, [actionKey, values]) => {
			const normalizedValues = normalizeScopeValues(values);
			if (normalizedValues.length) actionAcc[actionKey] = normalizedValues;
			return actionAcc;
		}, {});

		if (Object.keys(normalizedActionMap).length) acc[scopeKey] = normalizedActionMap;

		return acc;
	}, {});
};

export const pruneRoleScopes = (roleScopes = {}, flatRoles = {}) => filterScopesByEnabledServices(roleScopes, flatRoles);

export const buildRolePayload = (flatRoles = {}, roleScopes = {}) => {
	const normalizedFlatRoles = getFlatRoles(flatRoles);
	const normalizedRoleScopes = pruneRoleScopes(roleScopes, normalizedFlatRoles);

	if (!Object.keys(normalizedRoleScopes).length) return normalizedFlatRoles;

	return {
		...normalizedFlatRoles,
		__scopes: normalizedRoleScopes,
	};
};
